import _DatePicker from "antd/es/date-picker";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import moment from 'moment';
import DateChoice from '../../common/Question/DateChoice';
var FormItem = _Form.Item;
var DateChoicePC = /*#__PURE__*/function (_Component) {
  _inherits(DateChoicePC, _Component);
  function DateChoicePC() {
    _classCallCheck(this, DateChoicePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(DateChoicePC).apply(this, arguments));
  }
  _createClass(DateChoicePC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      return React.createElement(DateChoice, this.props, function (_ref) {
        var error = _ref.error,
          date = _ref.formAnswer.date,
          _onChange = _ref.onChange;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: question.required
        }, React.createElement(_DatePicker, {
          size: "large",
          style: {
            color: 'var(--primary-color) !important'
          },
          allowClear: false,
          value: date === undefined ? undefined : moment(date),
          placeholder: " ",
          onChange: function onChange(date, dateString) {
            if (!dateString) {
              return;
            }
            _onChange(dateString);
          }
        }));
      });
    }
  }]);
  return DateChoicePC;
}(Component);
export { DateChoicePC as default };